import {
  EEquipmentPhysicalTypeCategory,
} from '@/types/equipment.ts';

const category: Record<EEquipmentPhysicalTypeCategory, string> = {
  [EEquipmentPhysicalTypeCategory.BATCH_FURNACE]: 'Piece okresowe',
  [EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE]: 'Piece półciągłe',
  [EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE]: 'Piece ciągłe',
  [EEquipmentPhysicalTypeCategory.STORAGE]: 'Magazyn',
};

export default {
  placeholder: 'Wybierz typ fizyczny sprzętu',
  category,
};
